export default __webpack_public_path__ + "static/media/reload_icon.2e5838d5.svg";